import { gql } from 'graphql-request';
import { SpeciesTestTypes } from 'src/shared/types';

export const speciesTestTypesQuery = gql`
    query speciesTestTypes($projectId: String!) {
        fetchSpeciesTestTypes(projectId: $projectId) {
            species
            testTypes {
                habitatName
                assayName
                habitatAssayKey
            }
        }
    }
`;

export type SpeciesTestTypesQueryResult = {
    fetchSpeciesTestTypes: SpeciesTestTypes;
};
